






























import { computed, defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'SwiperPagination',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'bullets',
      validator: (value: string) =>
        ['bullets', 'fraction', 'custom'].includes(value)
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: true
    }
  },
  emits: ['pagination:click'],
  setup(props) {
    // Ensure activeIndex is within bounds
    const clampedActiveIndex = computed(() => {
      if (!props.items.length || props.activeIndex < 0) {
        return 0;
      }

      if (props.activeIndex >= props.items.length) {
        return props.items.length - 1;
      }

      return props.activeIndex;
    });

    return {
      clampedActiveIndex
    };
  }
});
